
<div class="page-header">
    <a routerLink="/gebruikersgroepen/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "user-roles.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-user-role-detail-form [userRole]="userRole$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>